import { selfAxios } from "../../../../../axios/selfAxios.js";
const reqGetMAActivityTypeCacheCOList = async (params) => {
  const { data } = await selfAxios.post("/mtdsbase/internal/cache/getMAActivityTypeCacheCOList", params);
  return data.data;
};
export { reqGetMAActivityTypeCacheCOList };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/mtdsbase/internal/cache/getMAActivityTypeCacheCOList/post.js